<h1 mat-dialog-title>{{ title | translate }}</h1>

<mat-dialog-content class="nda-dialog-content">
  <div class="nda-content-area" #contentArea>
    @if (isLoading) {
      <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    } @else {
      <div class="quill-editor-container">
        <quill-view
          class="form__main__editor"
          [content]="ndaTemplate$ | async"
          format="json">
        </quill-view>
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions class="nda-dialog-actions">
  <div
    [matTooltip]="!isScrolledToBottom ? 'GNR_READ_AGREEMENT' : ''"
    [matTooltipDisabled]="isScrolledToBottom"
    style="display: inline-block">
    <button
      [disabled]="isProcessingAction || isLoading"
      mat-button
      (click)="action('accepted')">
      @if (isProcessingAction) {
        <mat-icon>
          <mat-spinner diameter="18"></mat-spinner>
        </mat-icon>
      }
      {{ 'GNR_I_AGREE' | translate }}
    </button>
  </div>

  <button
    mat-button
    (click)="action('declined')"
    [disabled]="isProcessingAction">
    {{ 'GNR_DECLINE' | translate }}
  </button>

  <button mat-button (click)="back()" [disabled]="isProcessingAction">
    {{ 'CMD_BACK' | translate }}
  </button>
</mat-dialog-actions>
